import { render, staticRenderFns } from "./RegisterName.vue?vue&type=template&id=f04d99ce&scoped=true"
import script from "./RegisterName.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterName.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RegisterName.vue?vue&type=style&index=0&id=f04d99ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04d99ce",
  null
  
)

export default component.exports